




import { Component, Mixins, Watch } from "vue-property-decorator";
import StringFilter from "../../system/filters/StringFilter.vue";
import ProjectTeamDropDownSelector from "../../projectTeam/selectors/ProjectTeamDropDownSelector.vue";
import { BelongedAllDepartmentsUserFilterableMixin } from "./mixins";

@Component({
  components: {
    StringFilter,
    ProjectTeamDropDownSelector,
  },
})
export default class BelongedAllDepartmentsUserFilter extends Mixins(BelongedAllDepartmentsUserFilterableMixin) {
  data(): any {
    return {
      shouldFilter: false,
    };
  }
  shouldFilter: boolean;

  mounted() {
    this.shouldFilter = this.$configuration.behavior.user.finder.shouldFilterBelongedAllDepartmentsSelector;
  }

  @Watch("shouldFilter")
  onShouldFilteringChanged(newValue: boolean, oldValue: boolean) {
    if (newValue === oldValue) { return; }
    this.updateBelongedAllDepartmentsUsers(newValue);
  }

  @Watch("users")
  onUsersChanged() {
    if (!this.shouldFilter) { return; }
    this.updateBelongedAllDepartmentsUsers(this.shouldFilter);
  }
}
